import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  decoration: {
    margin: '10px 8px 10px 0px',
  },
  configItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.dimensions.inputs.borderRadius,
    marginBottom: 10,
    padding: 10,
    minHeight: 50 - 10 * 2,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
    cursor: 'move',
  },
  timePickerInput: {
    '&& .MuiInputBase-input': {
      fontSize: '1rem',
      padding: 4,
    },
  },
}));

export default useStyles;
